import { DocumentsListsPolicyModule } from '@folio/modules';

export const BrokerPolicyDashboardDocumentsView = () => {
  return (
    <div className="flex flex-col gap-4">
      <DocumentsListsPolicyModule displayContext="broker" />
    </div>
  );
};
